import { useTranslation } from 'react-i18next';
import { ACCOUNT_TYPES } from '@/helpers/constants';
import { MyTooltip } from '@/webkit/MyTooltip';
import { useUserStore } from '@/store/userStore';
import Icon from './icon.svg';
import s from './index.module.scss';

export const AccountTypeSwitch = () => {
  const { t } = useTranslation('components');
  const { accountType, setAccountType } = useUserStore();

  const onAccountChange = () => {
    setAccountType(accountType === ACCOUNT_TYPES.business ? ACCOUNT_TYPES.personal : ACCOUNT_TYPES.business);
  };

  return (
    <MyTooltip
      theme="dark"
      elementClassName={s.tooltip}
      placement="bottom"
      renderElement={() => (
        <button type="button" onClick={onAccountChange} className={s.wrapper}>
          <span className={s.label}>
            {accountType === ACCOUNT_TYPES.business
              ? t('acc_type_switch.business_account')
              : t('acc_type_switch.personal_account')}
          </span>
          <img src={Icon} alt="type" width={24} height={24} />
        </button>
      )}
      renderContent={() => (
        <div style={{ padding: '8px' }}>{t('acc_type_switch.swap_account_display')}</div>
      )}
    />
  );
};
